import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfessionalService } from '../../../shared/services/professional.service';

@Component({
  selector: 'app-dialog-change-password-professional',
  templateUrl: './dialog-change-password-professional.component.html',
  styleUrls: ['./dialog-change-password-professional.component.scss']
})
export class DialogChangePasswordProfessionalComponent implements OnInit {
  passwordForm: FormGroup;
  messageError: string;
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
    private readonly snackbar: MatSnackBar,
    private readonly professionalService: ProfessionalService,
  ) {}

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group({
      password: [
        '',
        [Validators.required, Validators.minLength(6)],
      ],
      confirmPassword: [
        '',
        [Validators.required, Validators.minLength(6)],
      ],
    });
  }

  onSubmit() {
    this.messageError = '';

    if (this.passwordForm.invalid) return;

    if (this.passwordForm.value.password !== this.passwordForm.value.confirmPassword) {
      this.messageError = 'As senhas são diferentes';
      return;
    }

    this.isLoading = true;

    this.professionalService.updatePasswordById(this.data.professionalId, this.passwordForm.value.password).subscribe(
      () => {
        this.isLoading = false;
        this.passwordForm.reset();
        this.snackbar.open('Senha atualizada com sucesso', 'OK', {
          duration: 3000,
        });
      },
      () => {
        this.isLoading = false;
        this.passwordForm.reset();
        this.snackbar.open('Erro ao atualizar a senha', 'OK', {
          duration: 3000,
        });
      }
    );
  }

  hasError(controlName: string, errorName: string) {
    return this.passwordForm.controls[controlName].hasError(errorName);
  }
}
